<template functional>
  <svg
    role="presentation"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink" 
    :width="props.size"
    :height="props.size"
    viewBox="0 0 16 16"
  >
    <g>
      <path
        d="M15.429,12.25H.572A.54.54,0,0,1,0,11.75V10.5A.54.54,0,0,1,.572,10H15.429a.54.54,0,0,1,.571.5v1.25A.54.54,0,0,1,15.429,12.25Zm0-5H.572A.54.54,0,0,1,0,6.75V5.5A.54.54,0,0,1,.572,5H15.429A.54.54,0,0,1,16,5.5V6.75A.54.54,0,0,1,15.429,7.25Zm0-5H.572A.54.54,0,0,1,0,1.75V.5A.54.54,0,0,1,.572,0H15.429A.54.54,0,0,1,16,.5V1.75A.54.54,0,0,1,15.429,2.25Z"
        transform="translate(0 1.875)"
        fill="#74788d"
      />
    </g>
  </svg>
</template>

<script>
export default {
  name: 'IconBars',

  props: {
    size: { type: [String, Number], default: '16px' },
  }
}
</script>